// import React from "react";
// import NewFilewiseStatusLogs from "../../Common/NewFilewiseStatusLogs";

// const POSTPROCESSING_URL = process.env.REACT_APP_POSTPROCESSING_URL || "http://localhost:8010";

// export default function PostProcessingFilewiseStatusLogs({ 
//     startIndex, 
//     endIndex, 
//     setStartIndex, 
//     setEndIndex, 
//     rowSelection, 
//     setRowSelection 
// }) {
//     const projectCode = sessionStorage.getItem("projectCode");
//     return (
//         <NewFilewiseStatusLogs
//             fetchFilewiseAPIURL={`${POSTPROCESSING_URL}/post-processing/filewisestatusrpt/${projectCode}`}
//             fileDetailsAPIURL="entries/filedetails"
//             CloseAPIURL="entries/close"
//             process_code="PP"
//             service="Post-Processing"
//             apiEndpoint={`${POSTPROCESSING_URL}/post-processing/filewisestatusrpt`}
//             startIndex={startIndex}
//             endIndex={endIndex}
//             setStartIndex={setStartIndex}
//             setEndIndex={setEndIndex}
//             rowSelection={rowSelection}
//             setRowSelection={setRowSelection}
//         />
//     );
// }

import React from "react";
import NewFilewiseStatusLogs from "../../Common/NewFilewiseStatusLogs";

const POSTPROCESSING_URL = process.env.REACT_APP_POSTPROCESSING_URL || "http://localhost:8010";

export default function PostProcessingFilewiseStatusLogs({ 
    startIndex, 
    endIndex, 
    setStartIndex, 
    setEndIndex, 
    rowSelection, 
    setRowSelection 
}) {
    const projectCode = sessionStorage.getItem("projectCode");

    console.log("PostProcessingFilewiseStatusLogs URLs:", {
        fetchFilewiseAPIURL: `${POSTPROCESSING_URL}/post-processing/filewisestatusrpt/${projectCode}`,
        fileDetailsAPIURL: `${POSTPROCESSING_URL}/post-processing/filedetails`,
        CloseAPIURL: `${POSTPROCESSING_URL}/post-processing/close`,
        GetResponseAPIURL: `${POSTPROCESSING_URL}/post-processing/getresponse`
    });
    
    return (
        <NewFilewiseStatusLogs
            fetchFilewiseAPIURL={`${POSTPROCESSING_URL}/post-processing/filewisestatusrpt/${projectCode}`}
            fileDetailsAPIURL={`${POSTPROCESSING_URL}/post-processing/filedetails`}
            CloseAPIURL={`${POSTPROCESSING_URL}/post-processing/close`}
            GetResponseAPIURL={`${POSTPROCESSING_URL}/post-processing/getresponse`}
            process_code="PP"
            apiBaseURL={POSTPROCESSING_URL}
        />
    );
}

